import moment from 'moment';
import { API_URL } from '../../../app-config/constants';
import { DownloadableFile } from '../../../types/DownloadableFile';
import { post } from '../request';

const ISO_DATE_ONLY = 'YYYY-MM-DD';

triggerPraiseExport.operation = 'COMMAND';
export function triggerPraiseExport(format: string, fromDate: Date, untilDate: Date): Promise<DownloadableFile> {
    return post(`${API_URL}/praise-export`, {
        getData: {
            format,
            from: fromDate ? moment(fromDate).format(ISO_DATE_ONLY) : undefined,
            until: untilDate ? moment(untilDate).format(ISO_DATE_ONLY) : undefined,
        },
    });
}
